import { useCallback, useEffect, useState } from 'react';
import { useObservableCache } from './observable-cache-provider';

const useObservableCacheItem = <T>(key: string): T | undefined => {
  const cache = useObservableCache();
  const [value, setValue] = useState<T | undefined>(
    cache.getItemSync<T>(key) ?? undefined
  );

  useEffect(() => {
    const subscription = cache.observe<T>(key).subscribe((data) => {
      setValue(data);
    });

    return () => {
      subscription?.unsubscribe();
    };
  }, [cache, key]);

  return value;
};

const useObservableCacheItemLazy = <T>(
  key: string
): (() => Promise<T | undefined>) => {
  const cache = useObservableCache();

  const callback = useCallback(async () => {
    const result = await cache.getItem<T>(key);
    return result ?? undefined;
  }, [key, cache]);

  return callback;
};

export { useObservableCacheItem, useObservableCacheItemLazy };
